'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _FeedbackForm = require('components/Playlist/FeedbackForm/FeedbackForm');

var _FeedbackForm2 = _interopRequireDefault(_FeedbackForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./PlaylistFeedbackForm.scss');

var PlaylistFeedbackForm = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(PlaylistFeedbackForm, _PureComponent);

  function PlaylistFeedbackForm() {
    (0, _classCallCheck3.default)(this, PlaylistFeedbackForm);
    return (0, _possibleConstructorReturn3.default)(this, (PlaylistFeedbackForm.__proto__ || (0, _getPrototypeOf2.default)(PlaylistFeedbackForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlaylistFeedbackForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          album = _props.album,
          line = _props.line,
          className = _props.className;


      if (!album.recipient_id) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.feedback, className) },
        _react2.default.createElement(_FeedbackForm2.default, {
          recipientId: album.recipient_id,
          contentKey: album.contentKey,
          sender: album.sender,
          line: line
        })
      );
    }
  }]);
  return PlaylistFeedbackForm;
}(_react.PureComponent), _class.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string,
  line: _propTypes2.default.bool
}, _class.defaultProps = {
  album: {}
}, _temp);
exports.default = PlaylistFeedbackForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/PlaylistFeedbackForm/PlaylistFeedbackForm.js
// module id = 2043
// module chunks = 1